<ng-container *ngTemplateOutlet="language === 'en' ? en : fr " />

<!--TEMPLATES ENGLISH-->
<ng-template #en>
  <div class="td-wb-preferences__agreement-form">
    @if (disabled()) {
      <h1 class="td-wb-preferences__agreement-form__header">Platform Terms of Use</h1>
    }

    @if (disabled()) {
      <td-wb-notification class="td-wb-preferences-agreements__completed"
                          notificationType="success">
        Copy for "Viewing Purposes only" :
        No action required, this agreement has been accepted. Thank You.
      </td-wb-notification>
    }

    <p class="td-wb-preferences__agreement-form--title">ELECTRONIC BROKERAGE SERVICES<br>CLIENT AGREEMENT</p>

    <p class="td-wb-preferences__agreement-form--copy">
      IMPORTANT: PLEASE READ THIS AGREEMENT BEFORE ACCESSING ANY OF THE WEBBROKER®, TALKBROKER®, TELEMAX®,
      OR ADVANCED DASHBOARD® PLATFORM SERVICES. YOUR USE OF ANY OF THE SERVICES AS DEFINED BELOW OR SIGNED
      ACKNOWLEDGEMENT WILL INDICATE THAT YOU HAVE READ THIS AGREEMENT AND WILL ACT AS YOUR ACCEPTANCE OF AND AGREEMENT
      TO BE BOUND BY THE TERMS AND CONDITIONS HEREIN AND ANY OTHER TERM, CONDITION OR RESTRICTION APPLICABLE IN
      RESPECT OF THE SERVICES. TD WATERHOUSE CANADA INC. SHALL PROVIDE THE SERVICES TO YOU ONLY UPON THE FOLLOWING
    TERMS AND CONDITIONS:</p>
    <p class="td-wb-preferences__agreement-form--copy">
      Throughout this Agreement, the words "you", "your", "yourself" and "yours"
      mean the Client and the words "we", "us", and "ours" mean TD Waterhouse Canada
      Inc., ("TD Waterhouse"), which term, where applicable, includes The Toronto-Dominion Bank or the
      Bank's subsidiaries.
    </p>
    <p class="td-wb-preferences__agreement-form--copy">
      In consideration of us providing you access to the Services, you agree to the following:
    </p>

    <p class="td-wb-preferences__agreement-form--copy"><span class="td-wb-preferences__agreement-form--copy-bold">DEFINITIONS</span>
  </p>

  <p class="td-wb-preferences__agreement-form--copy">In this Agreement:</p>
  <ol class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--secondary">
    <li class="td-wb-preferences__agreement-form--secondary-item">"Access Device" means any device you use to access
      the Services, including but not limited to telephone,
      cellular phone, portable phone, personal computer, intelligent terminal or similar device.
    </li>
    <li class="td-wb-preferences__agreement-form--secondary-item">"Account" means your TD account(s) with us.</li>
    <li class="td-wb-preferences__agreement-form--secondary-item">"Account Number" means the number(s) assigned to
      your Account by TD Waterhouse.
    </li>
    <li class="td-wb-preferences__agreement-form--secondary-item">"Information" means any request which you place
      using any Access Device for account information or a
      stock, option, index, mutual fund or other security or market quotation including the bid/ask/last
      price/change etc. using the Services.
    </li>
    <li class="td-wb-preferences__agreement-form--secondary-item">"Information Providers" means any entity providing
      us with securities or market data, including but not
      limited to various securities markets such as stock exchanges and their affiliates.
    </li>
    <li class="td-wb-preferences__agreement-form--secondary-item">"Order Request" means any Buy, Sell or Short Sell
      trade request for stocks, options, mutual funds or
      other security that is created and transmitted via Access Device by you to us using the Services.
    </li>
    <li class="td-wb-preferences__agreement-form--secondary-item">"Password" means your existing Services personal
      password or security code or the personal password or
      security code assigned to you in connection with the Services, as same may be amended by you from time to
      time.
    </li>
    <li class="td-wb-preferences__agreement-form--secondary-item">"Personal Information" shall have the meaning set
      out in Section 9 below.
    </li>
    <li class="td-wb-preferences__agreement-form--secondary-item">"Services" means individually and collectively the
      WebBroker Internet trading service, the TeleMax
      telephone service, the TalkBroker telephone service, the Advanced Dashboard Platform, the Advanced Dashboard
      Plus
      Platform, the Advanced Dashboard Web Platform, and the Order Entry Service component or any element of these
      services as applicable.
    </li>
  </ol>
  <ol class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--primary">
    <li class="td-wb-preferences__agreement-form--primary-item">In order to use the Services, your application must be
      accepted by us, in our sole discretion. Your first
      use of any of the Services will act as your acceptance of an agreement to be bound by the terms and
      conditions herein (as amended from time to time) and your acceptance of any other term, condition or
      restriction applicable in respect of the Services.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">You may use your Password with your Account Number to
      access the Services provided. You may also use your
      Password(s) to enter Order Requests using the Services. You agree to keep your Password(s) confidential and
      separate from the Account Number.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">You agree not to disclose your Password(s) to any
      person and keep it separate from any other information
      which you will receive or which you already possess concerning the Services. You are solely responsible for
      maintaining the security of your Password(s) and ensuring that it is used for yourself only. You acknowledge
      that your Password(s) is unique to you and that we do not have access to your Password(s).
      <p class="td-wb-preferences__agreement-form--copy">TD Waterhouse is not responsible for unauthorized access to
        accounts online or losses that occur as a result
        of you voluntarily disclosing your Access Card, Connect ID or WebBroker password, or the careless or
      improper handling, storing or disclosure by you of this Information.</p>
      <p class="td-wb-preferences__agreement-form--copy">In the event of loss, theft, misuse or compromise of your
        Access Card, Connect ID and/or WebBroker password,
      you must notify TD Waterhouse within a reasonable time.</p>
      <p class="td-wb-preferences__agreement-form--copy">You will not attempt to enter restricted areas of our
        computer systems or the computer system of any entity
        related to or affiliated with us, or performs functions which you are not authorized to perform pursuant to
      this Agreement.</p>
      <p class="td-wb-preferences__agreement-form--copy">We may without notice temporarily suspend your access to the
        Services by deactivating your Password(s) if we
        reasonably suspect that you are using the Password(s) to obtain unauthorized access to our other systems or
        Information, or are using the Password(s) or the Services in any other inappropriate manner. These
        suspensions will be for a period of time necessary to permit the thorough investigation of such suspended
        activity. We may terminate this Agreement immediately without notice if we determine to our satisfaction
        that you have undertaken such unauthorized activity or if such unusual activity cannot be reasonably
      explained.</p>
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">Information provided through the Services has been
      independently obtained from various Information Providers
      through sources believed to be reliable. TD Waterhouse and the Information Providers do not guarantee the
      timeliness, sequence, accuracy and completeness of any market data or other information or messages that
      they disseminate. Neither TD Waterhouse or any Information Provider shall be liable in any way to you or any
      other person for (a) any inaccuracy, error or delay, or omission of, (i) any such data, information or
      message or (ii) the transmission or delivery of any such data, information or message, or (b) any loss or
      damage arising from or occasioned by any such inaccuracy, error, delay or omission or by reason of
      non-performance, or of interruption in any such data, information or message, either due to any negligent
      act or omission by any disseminating party or due to any "force majeure" (i.e. flood,
      extraordinary weather conditions, earthquake or other act of God, fire, war, insurrection, riot, labour
      dispute, accident, action of government, dispute, accident, communications or power failure, equipment or
      software malfunctions) or any cause beyond the reasonable control of any disseminating party.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">You agree that neither TD Waterhouse nor the
      Information Providers shall have any liability, contingent or
      otherwise, for the accuracy, completeness, timeliness or correct sequencing of the Information, or for any
      decision made or action taken by you in reliance upon the Information or Services, or for interruption of
      any data, information or aspect of the Services. We will not be responsible for any loss, damage or personal
      injury suffered by any person by reason of any act or omission in the course of or in connection with the
      operation of any Access Device by you.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">The securities and market data provided through the
      Services is proprietary to the Information Providers. By
      using the Services, you agree not to reproduce, retransmit, disseminate, sell, distribute, publish,
      broadcast, circulate or commercially exploit the data in any manner or furnish it to any other person
      without the express written consent of TD Waterhouse and the relevant Information Providers. You will use
      the securities and market data furnished hereunder only for your individual use.
      <p class="td-wb-preferences__agreement-form--copy">You agree that you will only access your Account(s), the
        Services or any information provided by you or any
        Information Provider through our website and not through a third party website or software. You will not
        permit any third party to access your Account(s), the Services or any information provided by you or any
        Information Provider through our website or through a third party website or software. You will not, and you
        will not permit any third party, to access or stream any data, including stock quotes or news, that
      originates from our website through any third party website or software.</p>
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">
      <ol class="td-wb-preferences__agreement-form--secondary">
        <li class="td-wb-preferences__agreement-form--secondary-item">YOU HEREBY AUTHORIZE US TO ACCEPT ALL
          TRANSACTIONS FOR YOUR ACCOUNT USING THE SERVICES AND YOU AGREE
          TO BE SOLELY RESPONSIBLE FOR THE ACCURACY OF ANY INSTRUCTIONS GIVEN BY YOU USING AN ACCESS DEVICE.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">ALL ORDER REQUESTS ARE SUBJECT TO VERIFICATION
          AND ACCEPTANCE BY US.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">YOU AGREE THAT ALL ORDER REQUESTS WILL ONLY BE
          PROCESSED IF YOUR ACCOUNT IS IN GOOD ORDER AND YOU
          HAVE SUFFICIENT FUNDS TO COMPLETE THE TRANSACTION ORDERED.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">YOU UNDERSTAND THAT ALL TRANSACTIONS MADE FOR
          YOUR ACCOUNT WILL BE SUBJECT TO THE RULES GOVERNING
          THE EXCHANGES OR MARKETS AND CLEARING HOUSES (IF ANY) WHERE THE ORDERS ARE EXECUTED, AND YOU AGREE
          TO COMPLY WITH THESE REQUIREMENTS.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">YOU UNDERSTAND THAT EXECUTION OF ANY ORDER
          REQUEST IS SUBJECT TO OUR PRIOR APPROVAL AND THAT TD
          WATERHOUSE HAS THE RIGHT TO REJECT, CHANGE OR REMOVE ANY ORDER ENTERED BY YOU OR TO CANCEL ANY TRADE
          RESULTING FROM AN ORDER ENTERED BY YOU.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">IN CERTAIN CIRCUMSTANCES, WE MAY REQUEST
          ADDITIONAL CONFIRMATION OF ANY ORDER REQUEST BEFORE
          EXECUTION OF SAME.
        </li>
      </ol>
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">All transactions based on information acquired from
      using the Services are subject to confirmation by us. IN
      NO EVENT WILL WE BE LIABLE TO YOU OR TO OTHERS FOR ANY DAMAGES, DIRECT, INDIRECT, CONSEQUENTIAL OR SPECIAL,
      INCLUDING WITHOUT LIMITATION ALL LOSSES, COSTS, EXPENSES, LOSS OF PROFITS, LOSS OF BUSINESS REVENUE OR
      FAILURE TO REALIZE EXPECTED SAVINGS ARISING FROM OR OUT OF THE EXISTENCE, FURNISHING OR FUNCTIONING OF THE
      SERVICES AS PROVIDED FOR IN THIS AGREEMENT. Neither TD Waterhouse nor any other party shall be held liable
      for the accuracy or timeliness of any quotation information provided through the Services.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">You agree that ALL INFORMATION THAT YOU PROVIDE TO US
      (INCLUDING YOUR ADDRESS, TELEPHONE NUMBER, AND
      INTERNET ADDRESS) ("Personal Information") is complete and true and the telephone number and
      Internet e-mail address at which you may be reached to discuss any Order Request you may submit to us using
      the Services is valid and current. You also agree to advise us of any change(s) in your Personal
      Information, including your contact telephone number(s) as soon as the change(s) occur.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">You agree to accept responsibility for any loss caused
      through the submission of an Order Request by an
      Access Device using the Services except where we determine that the provisions of the WebBroker Security
      Guarantee apply. You acknowledge that for mutual protection, TD Waterhouse will record all Order Request
      instructions from you pursuant to the Services.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">We may, at our sole discretion, act upon all
      instructions given or purported to be given by you or on your
      behalf in respect of an Order Request using the Services and we shall not incur any liability by reason of
      acting or failing to act due to an error in such Order Request.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">You agree and acknowledge that we may modify any or
      all of the Services at any time. You also agree that the
      Services may periodically be unavailable to you in order to allow for maintenance and updates.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">This Agreement is in addition to and not in
      substitution for any other present or future agreement between
      you and us, including any agreement relating to your Account or the Services.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">Any action of any kind by you against us arising as a
      result of this Agreement must be commenced within one
      year from the date the right, claim, demand or cause shall first occur.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">This Agreement confers certain rights upon the
      Information Providers. The Information Providers may enforce
      those rights against you by legal proceedings or other appropriate means.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">By using the Services, you acknowledge, for each
      Account, that there are charges for the use of the Services
      and you agree to accept responsibility for any charges incurred for the use of the Services.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">We can change the terms and conditions governing the
      use of the Services at any time. We will advise you of
      any changes in writing or via the Internet. We may cancel the Services at any time without notice to you.
    </li>
    <li class="td-wb-preferences__agreement-form--primary-item">
      <ol class="td-wb-preferences__agreement-form--secondary">
        <li class="td-wb-preferences__agreement-form--secondary-item"><span
        class="td-wb-preferences__agreement-form--copy-bold">Waiver:</span> No waiver by us of any breach of any
        provision or condition of this Agreement shall be
        deemed a waiver of any other breach of such provision or any similar or other provision or condition
        of this Agreement.
      </li>
      <li class="td-wb-preferences__agreement-form--secondary-item"><span
      class="td-wb-preferences__agreement-form--copy-bold">Agreement:</span> The conditions, rules and regulations
      set forth in any manuals, materials, documents or
      instructions relating to this Agreement form part of this Agreement.
    </li>
    <li class="td-wb-preferences__agreement-form--secondary-item"><span
    class="td-wb-preferences__agreement-form--copy-bold">Governing Law:</span> This Agreement shall be governed
    by and construed in accordance with the laws of the
    Province of Ontario and the laws of Canada applicable therein.
  </li>
  <li class="td-wb-preferences__agreement-form--secondary-item"><span
  class="td-wb-preferences__agreement-form--copy-bold">Notices:</span> Notices may be hand delivered or sent
  by mail, facsimile message or by e-mail. If sent by
  facsimile or by e-mail, notice shall be deemed to have been received upon transmission. If hand
  delivered, notice shall be deemed to have been received upon delivery, and if sent by mail, notice
  shall be deemed to have been received five days following the date of mailing.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">Successors and Assigns:</span> This Agreement shall be
binding upon the respective successors and permitted
assigns of the parties hereto.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">No Assignment:</span> You agree that you may not assign
the rights and obligations hereunder or in respect
of the Services without our prior written consent.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">Severability:</span> If any provision or condition of
this Agreement is held to be invalid or unenforceable
such invalidity or unenforceability shall attach only to such provision or condition. The validity
of the remainder of the Agreement shall not be affected and the Agreement shall be carried out as if
such invalid or unenforceable provision were not contained therein.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">Language:</span> This Agreement has been drafted and
executed in the English language at the express
request of the parties. Les parties ont exigé que le présent contrat soit rédigé
en anglais.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">Termination:</span> We may, at our sole discretion,
terminate your access to the Services without notice to
you. You agree that we are not liable to you in any way with respect to the termination of the
Services.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">Access Records:</span> You agree that TD Waterhouse
will maintain records of electronic access to your
accounts, including, but not limited to, login and logoff times and dates, and confirmation of
trading instructions received.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">Third Party Software:</span> From time to time, we may
make third party software available for your
convenience only. We assume no responsibility for the operation of the software or the accuracy or
completeness of the Information produced. We shall only be liable for the accuracy of the
Information contained in your TD Waterhouse statement of account. The Information produced by any
third party software may not be suitable for income tax or other reporting purposes, and its use is
entirely at the discretion of the user.
</li>
</ol>
</li>
</ol>
</div>
</ng-template>

<!--TEMPLATES FRENCH-->
<ng-template #fr>
  <div>
    @if (disabled()) {
      <h1 class="td-wb-preferences__agreement-form__header">Modalités d’utilisation de la plateforme</h1>
    }

    @if (disabled()) {
      <td-wb-notification class="td-wb-preferences-agreements__completed"
                          notificationType="success">
        Copie pour « À des fins de visualisation seulement » :
        Aucune mesure à prendre, ce contrat a été accepté. Merci.
      </td-wb-notification>
    }

    <p class="td-wb-preferences__agreement-form--title">
      CONVENTION DU CLIENT DES SERVICES DE
      <br>COURTAGE ÉLECTRONIQUES TD WATERHOUSE</p>
      <p class="td-wb-preferences__agreement-form--copy">
        REMARQUE IMPORTANTE VEUILLEZ LIRE LA PRÉSENTE CONVENTION AVANT D'ACCÉDER À L'UN DES SERVICES COURTIERWEB®,
        TALKBROKER®, TÉLÉMAX® OU PLATEFORME AVANCÉE®. L'UTILISATION DE L'UN OU DE L'AUTRE DES SERVICES DÉFINIS CI-DESSOUS
        OU L'APPOSITION DE VOTRE SIGNATURE SUR L'ACCUSÉ DE RÉCEPTION INDIQUERA QUE VOUS AVEZ LU LA PRÉSENTE CONVENTION, ET
        QUE VOUS ACCEPTEZ D'ÊTRE LIÉ PAR LES MODALITÉS STIPULÉES AUX PRÉSENTES ET PAR TOUTE AUTRE MODALITÉ OU RESTRICTION
        APPLICABLE À L'ÉGARD DES SERVICES. TD WATERHOUSE CANADA INC. NE FOURNIRA LES SERVICES
        QU'EN FONCTION DES MODALITÉS SUIVANTES :
      </p>
      <p class="td-wb-preferences__agreement-form--copy">
        Dans la présente convention, les mots «vous», «votre», «vos» et « vôtre » désignent le client et les mots «nous»,
        «notre», «nos» et « nôtre » désignent TD Waterhouse Canada Inc.(« TD Waterhouse »), terme qui, le cas échéant,
        englobe La Banque Toronto-Dominion ou les filiales de la Banque.
      </p>
      <p class="td-wb-preferences__agreement-form--copy">
        En contrepartie de l'accès aux services que nous vous consentons, vous convenez de ce qui suit :
      </p>

      <p class="td-wb-preferences__agreement-form--copy">
        <span class="td-wb-preferences__agreement-form--copy-bold">DÉFINITIONS</span>
      </p>

      <p class="td-wb-agreement-p">Dans la présente convention :</p>
      <ol class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--secondary">
        <li class="td-wb-preferences__agreement-form--secondary-item">
          « Appareil d'accès » désigne l'équipement dont vous avez besoin pour accéder aux services, ce qui inclut, sans
          s'y limiter, le téléphone, le téléphone cellulaire, le téléphone portable, l'ordinateur personnel, le terminal
          intelligent ou d'autres appareils semblables.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">
          « Compte » désigne le ou les comptes que vous détenez à TD Waterhouse.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">
          « Numéro de compte » désigne le ou les numéros de compte attribué(s) à votre compte par TD Waterhouse.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">
          « Information » désigne toute demande que vous faites à l'aide de n'importe quel appareil d'accès pour obtenir
          des renseignements sur un compte ou le cours d'une action, d'une option, d'un indice boursier, d'un fonds commun
          de placement ou autre titre ou autre cote de marché, incluant le cours vendeur, le cours acheteur, les derniers
          cours, les variations, etc., en utilisant les Services.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">
          « Fournisseurs de renseignements » désigne toute entité nous fournissant des données relatives aux titres ou aux
          marchés, ce qui inclut, sans s'y limiter, divers marchés des valeurs mobilières comme les marchés boursiers et
          leurs affiliés.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">
          « Ordre » désigne une demande de négocier une vente, un achat ou une vente à découvert d'actions, d'options, de
          fonds communs de placement ou d'autres titres que vous initiez, puis que vous nous transmettez par
          l'intermédiaire d'un appareil d'accès en utilisant les services .
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">
          « Mot de passe » désigne soit le mot de passe personnel ou le code de sécurité que vous utilisez déjà avec des
          services existants, soit le mot de passe personnel ou le code de sécurité qui vous ont été attribués
          relativement aux services, que vous pouvez modifier périodiquement.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">
          « Renseignements personnels » a le sens qui est attribué à l'article 9 ci-après.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item">
          « services » désigne individuellement et collectivement le service de courtage Internet CourtierWeb, le service
          téléphonique TéléMax, le service téléphonique TalkBroker, la plateforme Plateforme avancée, la plateforme
          Plateforme avancée Plus, la plateforme Plateforme avancée Web et la composante d'un service d'introduction d'un
          ordre ou tout élément de ces services, selon le cas.
        </li>
      </ol>
      <ol class="td-wb-preferences__agreement-form--copy td-wb-preferences__agreement-form--primary">
        <li class="td-wb-preferences__agreement-form--primary-item">Pour utiliser les services, votre demande doit avoir
          été acceptée par nous, à notre seule discrétion. L'utilisation initiale de l'un des Services constitue une
          acceptation de votre part d'être lié par les modalités et conditions de la présente convention (telles qu'elles
          peuvent être modifiées, le cas échéant) et toutes les autres modalités, conditions ou restrictions applicables
          aux Services.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Vous pouvez utiliser votre mot de passe avec votre
          numéro de compte pour accéder aux services fournis. Vous pouvez également utiliser votre mot de passe pour
          entrer des ordres en utilisant les Services. Vous acceptez de garder votre mot de passe confidentiel et distinct
          du numéro de compte.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Vous vous engagez à ne dévoiler à quiconque votre mot
          de passe et à le garder à l'écart des autres renseignements que vous recevrez ou que vous possédez déjà
          concernant les Services. Il vous incombe exclusivement de protéger la confidentialité de votre mot de passe et
          de vous assurer que vous êtes le seul utilisateur. Vous reconnaissez que votre mot de passe vous est
          exclusivement réservés et que nous n'y avons pas accès.
          <p class="td-wb-preferences__agreement-form--copy">TD Waterhouse n'est pas responsable de l'accès non autorisé
            à vos comptes en ligne ou des pertes subies résultant de la divulgation volontaire par vous de votre numéro de
            carte Accès, de votre ID de connexion ou de votre mot de passe CourtierWeb, ou de leur utilisation,
          conservation ou divulgation de façon négligente ou inappropriée.</p>
          <p class="td-wb-preferences__agreement-form--copy">En cas de perte, de vol, d'utilisation malveillante ou de
            compromission de votre carte Accès, de votre ID de connexion et/ou de votre mot de passe CourtierWeb, vous
          devez aviser en TD Waterhouse dans un délai raisonnable.</p>
          <p class="td-wb-preferences__agreement-form--copy">Vous ne tenterez pas d'accéder aux zones restreintes de nos
            systèmes informatiques ou au système informatique d'une entité reliée ou affiliée ni d'accomplir des fonctions
          que vous n'êtes pas autorisé à accomplir aux termes de la présente convention. </p>
          <p class="td-wb-preferences__agreement-form--copy">Nous pouvons, sans avis, suspendre temporairement votre
            accès aux services en désactivant votre ou vos mots de passe si nous avons des motifs raisonnables de
            soupçonner que vous utilisez le ou les mots de passe pour obtenir un accès non autorisé à nos autres systèmes
            ou renseignements, ou que vous utilisez votre ou vos mots de passe ou les services de toute autre façon
            inappropriée. Ces suspensions dureront le temps nécessaire pour permettre une enquête approfondie sur
            l'activité ayant fait l'objet de la suspension. Nous pouvons mettre fin à la présente convention immédiatement
            sans avis si nous établissons à notre satisfaction que vous vous êtes livré à une telle activité non autorisée
          ou que l'activité inhabituelle ne peut être raisonnablement expliquée. </p>
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Les renseignements fournis au moyen des services ont
          été obtenus de façon indépendante auprès de divers fournisseurs de renseignements par l'intermédiaire de sources
          que nous croyons fiables. Ni TD Waterhouse ni les fournisseurs de renseignements ne garantissent l'actualité, la
          séquence, l'exactitude et l'exhaustivité des données du marché ni de toute autre information ou des messages
          qu'ils diffusent. Ni TD Waterhouse ni les fournisseurs de renseignements ne seront responsables de quelque
          manière que ce soit envers vous ou toute autre personne en cas a) d'inexactitude, d'erreur de retard ou
          d'omission (i) dans ces données, cette information ou ces messages, ou (ii) dans la transmission ou la livraison
          de ces données, de cette information ou de ces messages, ou en cas b) de perte ou de dommage résultant d'un tel
          retard ou d'une telle inexactitude, erreur ou omission, ou causé par celui-ci, ou par la non-exécution ou
          l'interruption de ces données, de cette information ou de ces messages, en raison d'un acte de négligence ou
          d'une omission de la partie qui les diffuse, d'un cas de « force majeure » (inondation, conditions
          météorologiques extraordinaires, tremblement de terre ou autre catastrophe naturelle, incendie, guerre,
          insurrection, émeute, conflit de travail, accident, acte du gouvernement, conflit, panne de courant ou de
          communications, mauvais fonctionnement du matériel ou de logiciels) ou de toute autre cause hors du contrôle
          raisonnable de la partie qui les diffuse.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Vous convenez que ni TD Waterhouse ni les
          fournisseurs renseignements n'assumeront de responsabilité, éventuelle ou autre, pour l'exactitude,
          l'intégralité, l'actualité ou la séquence adéquate de l'information, ou pour toute décision ou mesure prise par
          vous en vous fiant à l'information ou aux Services, ou pour l'interruption de toute donnée, toute information ou
          tout aspect des Services. Nous n'assumerons aucune responsabilité pour toute perte, tout dommage ou tout
          préjudice personnel subi par quiconque, résultant de tout acte ou de toute omission relativement à votre
          utilisation d'un appareil d'accès.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">
          <p class="td-wb-preferences__agreement-form--copy">
            Les données sur les valeurs mobilières et le marché fournies par l'intermédiaire des Services sont la
            propriété exclusive des fournisseurs de renseignements. En utilisant les Services, vous acceptez de ne pas
            reproduire, retransmettre, diffuser, vendre, distribuer, publier, émettre, faire circuler ou exploiter
            commercialement les données d'une manière quelconque et de ne les fournir à personne d'autre sans le
            consentement exprès par écrit de TD Waterhouse et des fournisseurs de renseignements intéressés. Les données
            sur les valeurs mobilières et le marché fournies en vertu des présentes ne devront servir qu'à votre usage
          personnel.</p>
          <p class="td-wb-preferences__agreement-form--copy">Vous vous engagez à n'accéder à votre (vos) compte(s), aux
            Services ou à tout renseignement fourni par vous ou un fournisseur de renseignements que par l'intermédiaire
            de notre site Web et non par celui du site ou du logiciel d'un tiers. Vous ne permettrez à aucun tiers
            d'accéder à votre ou vos comptes, aux Services ou à une information fournie par vous ou un fournisseur de
            renseignements par l'intermédiaire de notre site Web ou du site Web ou logiciel d'un tiers. Vous n'accéderez
            pas, et ne permettrez à aucun tiers d'accéder aux données, y compris les cotations ou nouvelles boursières,
          provenant initialement de notre site Web, par l'intermédiaire du site Web ou logiciel d'un tiers. </p>
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">
          <ol class="td-wb-preferences__agreement-form--secondary">
            <li class="td-wb-preferences__agreement-form--secondary-item">VOUS NOUS AUTORISEZ PAR LES PRÉSENTES À
              ACCEPTER TOUTES LES OPÉRATIONS QUI SE FONT DANS VOTRE COMPTE EN UTILISANT LES SERVICES ET VOUS ACCEPTEZ
              D'ASSUMER SEUL LA RESPONSABILITÉ DE L'EXACTITUDE DES INSTRUCTIONS QUE VOUS NOUS DONNEZ À L'AIDE DES
              APPAREILS D'ACCÈS.
            </li>
            <li class="td-wb-preferences__agreement-form--secondary-item">TOUTE LES ORDRES SONT ASSUJETTIS À NOTRE
              VÉRIFICATION ET À NOTRE ACCEPTATION..
            </li>
            <li class="td-wb-preferences__agreement-form--secondary-item">VOUS CONVENEZ QUE TOUS LES ORDRES NE SERONT
              TRAITÉS QUE SI VOTRE COMPTE EST EN RÈGLE, QUE VOUS POSSÉDEZ LES FONDS SUFFISANTS POUR CONCLURE LES
              OPÉRATIONS PRÉCISÉES DANS LES ORDRES.
            </li>
            <li class="td-wb-preferences__agreement-form--secondary-item">VOUS COMPRENEZ QUE TOUTES LES OPÉRATIONS
              FAITES DANS VOTRE COMPTE SERONT ASSUJETTIES AUX RÈGLES RÉGISSANT LES BOURSES OU MARCHÉS ET CHAMBRES DE
              COMPENSATION (LE CAS ÉCHÉANT) DE L'ENDROIT OÙ LES ORDRES SONT EXÉCUTÉS, ET VOUS ACCEPTEZ DE VOUS CONFORMER À
              CES EXIGENCES.
            </li>
            <li class="td-wb-preferences__agreement-form--secondary-item">VOUS COMPRENEZ QUE L'EXÉCUTION DES ORDRES EST
              ASSUJETTIE À NOTRE APPROBATION PRÉALABLE ET QUE TD WATERHOUSE PEUT REFUSER, MODIFIER OU SUPPRIMER UN ORDRE
              INSCRIT PAR VOUS OU ANNULER UNE OPÉRATION RÉSULTANT D'UN ORDRE INSCRIT PAR VOUS.
            </li>
            <li class="td-wb-preferences__agreement-form--secondary-item">DANS CERTAINES CIRCONSTANCES, NOUS POUVONS
              DEMANDER UNE CONFIRMATION ADDITIONNELLE AVANT D'EXÉCUTER L'ORDRE EN QUESTION.
            </li>
          </ol>
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Toutes les opérations fondées sur les renseignements
          acquis en raison de l'utilisation des Services sont assujetties à notre confirmation. TOUTEFOIS, NOUS N'ASSUMONS
          AUCUNE RESPONSABILITÉ ENVERS VOUS OU ENVERS D'AUTRES PERSONNES POUR DES DOMMAGES DIRECTS, INDIRECTS, CONSÉCUTIFS
          OU PARTICULIERS COMPRENANT, SANS S'Y LIMITER, TOUS COÛTS OU TOUTES PERTES, DÉPENSES, PERTES DE PROFIT, PERTES DE
          REVENU D'AFFAIRES OU INCAPACITÉ DE RÉALISER DES ÉCONOMIES ANTICIPÉES DÉCOULANT DE LA MISE EN PLACE, DE LA
          FOURNITURE OU DU FONCTIONNEMENT DES SERVICES COUVERTS PAR LA PRÉSENTE CONVENTION. Ni TD Waterhouse ni qui que ce
          soit ne sera responsable de l'exactitude ou de l'opportunité
          d'une cotation transmise par l'intermédiaire des Services.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Vous affirmez que TOUS LES RENSEIGNEMENTS QUE VOUS
          NOUS FOURNISSEZ (Y COMPRIS VOS ADRESSE, NUMÉRO DE TÉLÉPHONE ET ADRESSE INTERNET) (« Renseignements personnels »)
          sont complets et exacts et que le numéro de téléphone ainsi que l'adresse Internet indiqués pour vous joindre au
          sujet des ordres que vous pourriez nous soumettre en utilisant les Services sont valables et à jour. Vous vous
          engagez aussi à nous informer de tous changements dans vos renseignements personnels et dans le ou les numéros
          de téléphone permettant de vous joindre, aussitôt qu'ils surviennent.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Vous consentez à assumer la responsabilité de toute
          perte découlant de la soumission d'un ordre à l'aide d'un appareil d'accès en utilisant les services sauf si
          nous établissons que les dispositions de la garantie de sécurité du CourtierWeb s'appliquent. Vous reconnaissez
          que pour notre protection mutuelle, TD Waterhouse enregistrera toutes vos instructions relatives aux ordres
          donnés en conformité avec les Services.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Nous pouvons, à notre seule gré, agir suivant les
          directives qui nous ont été données ou qui sont censées nous avoir été données par vous ou par quelqu'un en
          votre nom par rapport à un ordre, en utilisant les Services. Vous admettez que nous n'assumerons aucune
          responsabilité pour avoir agi ou omis d'agir s'il s'est glissé une erreur dans un tel ordre.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Vous acceptez et reconnaissez que nous pouvons
          apporter en tout temps des modifications partielles ou complètes aux Services. Vous consentez aussi à ce que les
          Services puissent être interrompus de façon périodique pour en faciliter l'entretien et la mise à jour.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">La présente convention s'ajoute à toute autre
          entente actuelle ou éventuelle entre vous et nous, y compris toute convention touchant votre compte ou les
          Services, et ne la remplace nullement.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Toute action, quelle qu'elle soit, que vous pourriez
          prendre contre nous par rapport à la présente convention, doit être instituée en deçà d'un an de la date à
          laquelle le droit, la réclamation, la demande ou la cause d'action ont pris naissance.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">La présente convention confère certains droits aux
          fournisseurs de renseignements. Les fournisseurs de renseignements peuvent faire valoir ces droits contre le
          client en intentant des poursuites judiciaires ou par d'autres moyens appropriés.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">En ayant recours aux Services, vous convenez, pour
          chaque compte, que des frais sont exigés pour l'utilisation des Services et vous convenez d'assumer la
          responsabilité de tous frais engagés pour l'utilisation des Services.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">Nous pouvons modifier les modalités et conditions
          touchant l'utilisation des Services en tout temps. Nous vous informerons de tout changement par avis écrit ou
          par Internet. Nous pouvons annuler les Services en tout temps sans vous en aviser.
        </li>
        <li class="td-wb-preferences__agreement-form--primary-item">
          <ol class="td-wb-preferences__agreement-form--secondary">
            <li class="td-wb-preferences__agreement-form--secondary-item">
              <span class="td-wb-preferences__agreement-form--copy-bold">Renonciation</span> - Aucune renonciation par
              nous à l'égard d'une contravention à une disposition ou condition de la présente convention n'est réputée
              constituer une renonciation à l'égard d'une autre contravention à ladite disposition ou à toute autre
              disposition ou condition, semblable ou non, de la présente convention.
            </li>
            <li class="td-wb-preferences__agreement-form--secondary-item"><span
            class="td-wb-preferences__agreement-form--copy-bold">Convention</span> - Les modalités, règles et
            règlements stipulés dans les manuels, le matériel, les documents ou les instructions se rapportant à la
            présente convention en font partie intégrante.
          </li>
          <li class="td-wb-preferences__agreement-form--secondary-item"><span
          class="td-wb-preferences__agreement-form--copy-bold">Lois applicables</span> - La présente convention est
          régie et interprétée en vertu des lois de la province de l'Ontario ainsi que des lois du Canada qui y sont
          applicables.
        </li>
        <li class="td-wb-preferences__agreement-form--secondary-item"><span
        class="td-wb-preferences__agreement-form--copy-bold">Avis</span> - Les avis peuvent être livrés de main à
        main, par la poste ou transmis par télécopieur ou par courrier électronique. Les avis télécopiés ou envoyés
        par courrier électronique sont censés avoir été reçus au moment de leur transmission. S'il est livré par
        porteur, un avis est réputé avoir été reçu sur livraison; s'il est transmis par la poste, un avis est réputé
        avoir été reçu cinq jours après avoir été mis à la
        poste.
      </li>
      <li class="td-wb-preferences__agreement-form--secondary-item"><span
      class="td-wb-preferences__agreement-form--copy-bold">Successeurs et ayants droit</span> - La présente
      convention lie les successeurs et ayants droit respectifs des parties aux présentes.
    </li>
    <li class="td-wb-preferences__agreement-form--secondary-item"><span
    class="td-wb-preferences__agreement-form--copy-bold">Incessibilité</span> - Vous reconnaissez que vous ne
    pouvez céder les droits et obligations en vertu des présentes ou à l'égard des Services sans obtenir au
    préalable notre autorisation écrite.
  </li>
  <li class="td-wb-preferences__agreement-form--secondary-item"><span
  class="td-wb-preferences__agreement-form--copy-bold">Divisibilité</span> - Si une disposition ou condition
  de la présente convention est déclarée nulle ou non exécutoire, seule cette disposition ou condition sera
  considérée comme nulle ou non exécutoire. La validité du reste de la convention ne sera pas touchée, et la
  convention continuera à lier les parties comme si cette disposition nulle ou non exécutoire n'avait jamais
  fait partie de la convention.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">Cessation</span> - Nous pouvons, à notre seul gré,
mettre fin à votre accès aux services sans préavis. Vous acceptez que nous n'engagions aucune responsabilité
envers vous d'une manière quelconque en ce qui a trait à la cessation des services.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">Accès aux dossiers</span> - Vous acceptez que TD
Waterhouse maintienne des dossiers sur l'accès électronique à vos comptes, y compris, notamment, les heures
et les dates d'ouverture et de fermeture de session et la confirmation des directives reçues relativement à
des opérations.
</li>
<li class="td-wb-preferences__agreement-form--secondary-item"><span
class="td-wb-preferences__agreement-form--copy-bold">Logiciel de tiers</span> - Nous pouvons, de temps à
autre, mettre à votre disposition des logiciels de tiers et ce, uniquement pour votre commodité. Nous ne
sommes pas responsables du fonctionnement du logiciel ni de l'exactitude ou de l'exhaustivité des
renseignements produits.Nous serons responsable uniquement de l'exactitude des renseignements contenus dans
votre relevé de compte TD Waterhouse. Les renseignements produits par tout logiciel de tiers peuvent ne pas
convenir aux fins de l'impôt sur le revenu ou à d'autres fins de déclaration, et leur utilisation se fait à
l'entière discrétion de l'utilisateur.
</li>
</ol>
</li>
</ol>
</div>
</ng-template>
